// eslint-disable-next-line import/prefer-default-export

export function hideLoadingSpinner() {
  const spinner = document.getElementById('loadingSpinner')
  if (spinner) {
    spinner.classList.add('opacity-0')
    setTimeout(() => {
      spinner.style.display = 'none'
    }, 300)
  }
}